(() => {
  const boot = root => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const targets = root.querySelectorAll('.world-image,.hero__media,.mascot-stories__head');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        observer.unobserve(el);
        if (el.dataset.pkRemixSeen) return;
        el.dataset.pkRemixSeen = 'true';
        el.animate([{opacity:.65,translate:'0 16px',rotate:'-.6deg'},{opacity:1,translate:'0 0',rotate:'0deg'}],{duration:650,easing:'cubic-bezier(.2,.8,.2,1)'});
      });
    },{threshold:.12});
    targets.forEach(el => observer.observe(el));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => boot(document),{once:true});
  else boot(document);
  document.addEventListener('shopify:section:load',event => boot(event.target));
})();